<template>
  <LandingFeaturesCoverItem>
        <template slot="cover">
          <img v-if="lang === 'en-GB'" src="../../../assets//img/covers/monitorizacion-precios-wishlist-EN.png" alt="" />
          <img v-else-if="lang === 'es-ES'" src="../../../assets//img/covers/monitorizacion-precios-wishlist-ES.png" alt="" />
          <img v-else-if="lang === 'fr-FR'" src="../../../assets//img/covers/monitorizacion-precios-wishlist-FR.png" alt="" />
          <img v-else-if="lang === 'it-IT'" src="../../../assets//img/covers/monitorizacion-precios-wishlist-IT.png" alt="" />
          <img v-else-if="lang === 'pt-BR'" src="../../../assets//img/covers/monitorizacion-precios-wishlist-BR.webp" alt="" />
          <img v-else src="../../../assets//img/covers/monitorizacion-precios-wishlist-EN.png" alt="" />
        </template>
        <template slot="titulo"> {{ $t("landings.updateListSection.title", lang)}} </template>

        <template slot="descripcion">
          <p>
            {{ $t("landings.updateListSection.description", lang) }}
          </p>
        </template>
        <template slot="footnote">
          <p>
            {{ $t("landings.updateListSection.footnote", lang) }}
          </p>
        </template>
      </LandingFeaturesCoverItem>
</template>

<script>

import LandingFeaturesCoverItem from "./LandingFeaturesCoverItem.vue";

export default {
  components: {
    LandingFeaturesCoverItem
  },
  props: {
    lang: {
      type: String,
      required: true,
      default: "en-GB"
    }
  }
};
</script>
